import { useEffect, useState } from 'react';
import TechCard from './tech-card/TechCard';
import { useTranslation } from 'react-i18next';
import { Row, Col, Container } from 'react-bootstrap';
import { getLocalisedOpswatLink } from '@mdc/services';

import './SecurityTechnologies.scss';

const SecurityTechnologies = () => {
    const { t, ready } = useTranslation();
    const [securityTechnologies, setSecurityTechnologies] = useState(undefined);

    const onCardClick = (href) => {
        window.location.href = href;
    };

    useEffect(() => {
        setSecurityTechnologies(<Col>
            <Row className="justify-content-center">
                <Col>
                    <TechCard
                        href={getLocalisedOpswatLink('https://www.opswat.com/technologies/proactive-data-loss-prevention')}
                        iconClass="icon-proactive-dlp"
                        onCardClick={onCardClick}
                        text={t('Proactive DLP')}
                    />
                </Col>
                <Col>
                    <TechCard
                        href={getLocalisedOpswatLink('https://www.opswat.com/technologies/data-sanitization')}
                        iconClass="icon-proactive-dlp"
                        onCardClick={onCardClick}
                        text={t('Deep CDR')}
                    />
                </Col>
            </Row>
            <Row className="justify-content-center">
                <Col>
                    <TechCard
                        href={getLocalisedOpswatLink('https://www.opswat.com/technologies/vulnerability-assessment')}
                        iconClass="icon-vulnerabilities"
                        onCardClick={onCardClick}
                        smallText="U.S. 9749349 B1"
                        text={t('Vulnerabilities')}
                    />
                </Col>
                <Col>
                    <TechCard
                        href='https://onlinehelp.opswat.com/mdcloud/4._Dynamic_analysis.html'
                        iconClass="icon-sandbox"
                        onCardClick={onCardClick}
                        text={t('Sandbox')}
                    />
                </Col>
            </Row>
            <Row className="justify-content-center">
                <Col>
                    <TechCard
                        href={getLocalisedOpswatLink('https://www.opswat.com/technologies/multiscanning')}
                        iconClass="icon-multiscan"
                        onCardClick={onCardClick}
                        text={t('Multiscanning')}
                    />
                </Col>
                <Col>
                    <TechCard
                        href={getLocalisedOpswatLink('https://www.opswat.com/technologies/big-data-cloud-security-platform')}
                        iconClass="icon-threat-intelligence"
                        onCardClick={onCardClick}
                        text={t('Threat Intelligence')}
                    />
                </Col>
            </Row>
        </Col>);
    }, [t]);

    if (!ready) {
        return null;
    }

    return (
        <Container className="security-technologies">
            <p className='h4Mask'>
                {t('Security Technologies')}
            </p>

            {securityTechnologies}
        </Container>
    );
};

export default SecurityTechnologies;
